import React, { FC, Fragment, useMemo } from 'react';
import { Checkbox, Bubble, Form } from 'tea-component';
import { useIntl } from 'umi';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
interface FormCheckboxProps {
  options: any[];
  formModel: any;
  setFormModelState?: any;
  tableParams?: any;
  field: string;
  // disabledCheckbox?: boolean;
  showBatchOperation?: boolean;
  disabledGsd?: boolean;
  disabledFamitsu?: boolean;
  disabledNpd?: boolean;
  disabledMscience?: boolean;
  onChange: (data: { [key: string]: any }) => void;
  translater?: any;
}

const FormCheckbox: FC<FormCheckboxProps> = (props) => {
  const {
    options,
    formModel,
    field,
    onChange,
    showBatchOperation = false,
    disabledGsd = false,
    disabledFamitsu = false,
    disabledNpd = false,
    disabledMscience = false,
    translater,
  } = props;
  const { formatMessage } = useIntl();

  const disabledCheckbox = useMemo(() => {
    switch (field) {
      case 'download_devices_gsd':
        return disabledGsd;
      case 'download_devices_mscience':
        return disabledMscience;
      case 'download_devices_npd':
        return disabledNpd;
      case 'download_devices_famitsu':
        return disabledFamitsu;
      default:
        return false;
    }
  }, [props]);

  const selectedValues = formModel?.[field] || [];
  const enabledOptions = options?.filter((item) => !item?.disabled) || [];
  const enabledValues = enabledOptions.map((item) => item.value);
  const isAllSelected =
    enabledValues.length > 0 &&
    enabledValues.every((value) => selectedValues.includes(value));

  const handleBatchOperation = () => {
    onChange({
      [field]: isAllSelected ? [] : enabledValues,
    });
  };

  return (
    <>
      {showBatchOperation && enabledOptions.length > 1 && (
        <div className="dbi-download-checkbox-batch">
          <a className="dbi-download-checkbox-batch-btn" onClick={handleBatchOperation}>
            {formatMessage({
              id: isAllSelected ? 'dbi_clear_all' : 'dbi_select_all',
            })}
          </a>
        </div>
      )}
      {options?.length > 1 ? (
        <Checkbox.Group
          value={selectedValues}
          onChange={(value) =>
            onChange({
              [field]: value,
            })
          }
        >
          {options?.length > 0 &&
            options?.map((item) => (
              <Bubble
                key={item.value}
                dark
                className="bubble-all-bg"
                overlayClassName="topcharts-download-bubble"
                trigger="hover"
                placement="top"
                content={disabledCheckbox ? item?.disabledmessage || '' : ''}
              >
                <Fragment key={item?.value}>
                  <Checkbox
                    disabled={disabledCheckbox ? disabledCheckbox : item?.disabled}
                    name={disabledCheckbox ? '' : item?.value}
                  >
                    {(item.dataSource || item.source) && (
                      <img
                        src={getDataSourceIcon(item.dataSource || item.source)}
                      />
                    )}
                    {translater?.({ id: item?.label })}
                    {item?.message && (
                      <TipContext
                        tipText={translater?.({ id: item?.message })}
                        className="checkbox-group-tip"
                      />
                    )}
                  </Checkbox>
                </Fragment>
              </Bubble>
            ))}

          {/* {options?.map((item) => (
            <Fragment key={item?.value}>
              <Checkbox disabled={item?.disabled} name={item?.value}>
                {item?.label}
                {item?.message && <TipContext tipText={item?.message} className="checkbox-group-tip" />}
              </Checkbox>
            </Fragment>
          ))} */}
        </Checkbox.Group>
      ) : (
        <Form.Text>{translater?.({ id: options[0]?.label })}</Form.Text>
      )}
    </>
  );
};

export default FormCheckbox;
